import { IWidgetProps } from "decorator-form";
import React from "react";
import { connect } from "react-redux";

import { configConditionAdd } from "core/actions/configActions";
import initialState from "core/reducers/initialState";
import StringUtil from "core/util/StringUtil";
import TextWidget from "./TextWidget";

class RemoteConditionWidget extends React.Component<IWidgetProps<string> & any & { conditions: any }> {

	public state = { loading: false };

	public render() {
		const { conditions = {}, value } = this.props;

		return (
			<TextWidget disabled={this.state.loading} onChange={this.handleChange} value={value && conditions[value]} />
		);
	}

	private handleChange = (externalId: string) => {
		const { conditions = {}, dispatch, onChange } = this.props;
		if (!externalId) {
			onChange(undefined);
			return;
		}

		// check if we already have this condition external ID
		for (const [uid, eid] of Object.entries(conditions)) {
			if (eid === externalId) {
				onChange(uid);
				return;
			}
		}

		this.setState({loading: true}, () => {
			// new condition external id, load value
			const uuid = StringUtil.generateUuid();
			dispatch(configConditionAdd(uuid, externalId)).then(() => {
				this.setState({loading: false}, () => onChange(uuid));
			});
		});
	}
}

export default connect<{ conditions: any }, any, IWidgetProps<string>>((state: typeof initialState) => ({ conditions: state.config.conditions }))(RemoteConditionWidget);



// WEBPACK FOOTER //
// ./src/common/form/widgets/RemoteConditionWidget.tsx